import * as React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';


export const SessionExpired = () => {
  const {t} = useLabelTranslation();

  return (
    <EmptyState
      imageVariant="calendar"
      title={t('Uh_oh_This_link_is_expired', 'Uh oh! This link is expired')}
      description={t(
        'Please_retry_with_a_new_link',
        'Please retry with a new link',
      )}
    />
  );
};
